let endpoints_PortalManagement_DEV_Develop = {
	insertD2DFileData: {
		url_NA: "https://us1.api.kimclark.com/kcc-sls-ang-priceagreement-pxy-api-dev/na/v2/D2DFile/InsertFilePreview",
		method: "POST"
	},
	getUserGroups: {
		url_NA: "https://us1.api.kimclark.com/kcc-sls-ang-priceagreement-pxy-api-dev/na/v2/SelfService/GetUserGroups",
		method: "POST"
	},
	getSelfServiceGroups: {
		url_NA: "https://us1.api.kimclark.com/kcc-sls-ang-priceagreement-pxy-api-dev/na/v2/SelfService/GetSelfServiceGroups",
		method: "GET"
	},
	updateUserGroups: {
		url_NA: "https://us1.api.kimclark.com/kcc-sls-ang-priceagreement-pxy-api-dev/na/v2/SelfService/UpdateUserGroups",
		method: "POST"
	},
	getNewUsers: {
		url_NA: "https://us1.api.kimclark.com/kcc-sls-ang-priceagreement-pxy-api-dev/na/v2/SelfService/GetNewUsers",
		method: "POST"
	},
	searchSSUsersResult: {
		url_NA: "https://us1.api.kimclark.com/kcc-sls-ang-priceagreement-pxy-api-dev/na/v2/SelfService/GetSSUserSearchResult",
		method: "POST"
	},
	getD2DSearchresult: {
		url_NA: "https://us1.api.kimclark.com/kcc-sls-ang-priceagreement-pxy-api-dev/na/v2/D2DFile/GetD2DSearch",
		method: "POST"
	},
	d2DFileDownload: {
		url_NA: "https://us1.api.kimclark.com/kcc-sls-ang-priceagreement-pxy-api-dev/na/v2/D2DFile/D2DFileDownload",
		method: "POST"
	},
	getUserDetailsByUserId: {
		url_NA: "https://us1.api.kimclark.com/kcc-sls-ang-kcpuser-pxy-api-dev/NA/v2/UserService/GetUserDetailsByUserId",
		method: "POST"
	},
	deletePCFile: {
		url_NA: "https://us1.api.kimclark.com/kcc-sls-ang-priceagreement-pxy-api-dev/NA/v2/PolicyCenter/ArchiveAndDeletePCFiles",
		method: "POST"
	},
	getInstructions: {
		url_NA: "https://us1.api.kimclark.com/kcc-sls-ang-priceagreement-pxy-api-dev/NA/v2/IPRefresh/GetInstructionsContent",
		method: "POST"
	},
	// invoice refesh search 
	getInvoiceRefeshSearchresult: {
		url_NA: "https://us1.api.kimclark.com/kcc-sls-ang-priceagreement-pxy-api-dev/NA/v2/SelfService/GetSelfServiceAuditSearchResult",
		method: "POST"
	},
	// invoice refesh customer validation 
	checkIPCustomerHierarchy: {
		url_NA: "https://us1.api.kimclark.com/kcc-sls-ang-priceagreement-pxy-api-dev/NA/v2/IPRefresh/GetHeirarchyLevelCustomerValidation",
		method: "POST"
	},
	selfServiceAudit: {
		url_NA: "https://us1.api.kimclark.com/kcc-sls-ang-priceagreement-pxy-api-dev/na/v2/SelfService/InsertSelfServiceAuditLog",
		method: "POST"
	}
}

export { endpoints_PortalManagement_DEV_Develop };